import { MjmlColumn, MjmlSection, MjmlSpacer } from "@faire/mjml-react";
import { memo } from "react";

export interface SpacerState {
  height: number;
  sectionColor: string;
}

export const EmailSpacer = memo(function EmailSpacer(state: SpacerState) {
  return (
    <MjmlSection backgroundColor={state.sectionColor}>
      <MjmlColumn>
        <MjmlSpacer height={state.height} />
      </MjmlColumn>
    </MjmlSection>
  );
});
